// #586: Begleit-E-Mails des Schreiben-Assistenten enden mit der persönlichen E-Mail-Signatur des Absendenden
// (email_signaturen, RLS: nur die eigenen; die Standard-Signatur zuerst). Gesäubert wie im E-Mail-Fenster.
import DOMPurify from 'dompurify';
import { supabase } from '../supabase/client';

export async function ladeEigeneEmailSignatur(): Promise<{ name: string; html: string } | null> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;
  const { data, error } = await supabase.from('email_signaturen').select('name, html_signatur')
    .eq('user_id', user.id).order('ist_standard', { ascending: false }).order('created_at').limit(1).maybeSingle();
  if (error || !data?.html_signatur?.trim()) return null;
  const html = DOMPurify.sanitize(data.html_signatur, { USE_PROFILES: { html: true }, FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form'] });
  return html.trim() ? { name: (data.name as string) || 'Signatur', html } : null;
}
